<template>
  <section
    class="public-table media-buying-ad posts-view-table"
  >
    <TableCard
      ref="datatable"
      v-model:sort="sorting"
      v-model:page="page"
      v-model:page-size="pageSize"
      :loading="loading"
      :columns="columns"
      :sort-by-name="sortByName"
      :sort-dir-name="sortDirName"
      :rows="rows"
      :count="$store.state.mediaBuying.postsCount"
      :formaters="formaters"
      :actions="actions"
      :header="$t('mediaBuying.campaigns.posts')"
      is-static
      dont-fill-empty
      :disable-actions="isArchived"
      placement-tooltip="bottom"
      i18n-path="mediaBuying.posts"
      :tooltip-formatter="tooltipFormatter"
      @fetch-data="fetchDataTable"
    >
      <template v-slot:header>
        <div
          :class="[
            'ui-d-flex',
            'ui-desktop-no-wrap',
            'ui-mobile-wrap',
            'ui-mobile-12',
          ]"
        >
          <TableCardSearchHeader
            v-model="search"
            class="ui-g-md"
            @search="handleSearch"
          />

          <PeriodWrapper
            class="ui-g-md ui-mobile-12"
            :settings="period"
            default-all-time
            @update="period = $event"
            @change="changePeriod"
          />

          <UiFilters
            :use-filters="availableFilters"
            :filters="filters"
            :route="route"
            @input="inputFilter"
            @reset="reset"
          />
          <div
            class="checkbox payment-history__checkbox ui-mobile-12 ui-g-md"
          >
            <input
              id="checkbox1"
              v-model="actionRequired"
              type="checkbox"
              @change="fetchData"
            >
            <label
              class="checkbox-label checkbox-label__action-required"
              for="checkbox1"
            >
              {{ $t('mediaBuying.campaign.action_required') }}
            </label>
          </div>
        </div>
      </template>
    </TableCard>

    <ShowPost
      ref="showPost"
      :table-sorting="sorting"
      @add-post="update"
    />
    <AddPost
      id="PostsTable"
      ref="addPost"
      is-post-view
      @add-post="update"
    />
  </section>
</template>

<script>
import moment from 'moment';
import { h } from 'vue';
import UrlMixin from '@/components/Query/url-mixin';
import UrlMixinHooks from '@/components/Query/url-mixin-hooks';
import InjectPlugins from '@/components/Report/Components/inject-plugins';
import { pageSizeMixin } from '@/views/Dashboard/Reports/page_size';
import AddPost from '@/views/Dashboard/MediaBuying/Modal/AddPost.vue';
import ShowPost from '@/views/Dashboard/MediaBuying/Modal/ShowPost.vue';
import Formatters from '@/views/Dashboard/CustomReports/formaters';
import TableCard from '@/components/Cards/TableCard.vue';
import tableFlowMixinGenerator from '@/views/Dashboard/Reports/tableFlowMixin';
import TableCardSearchHeader from '@/components/Cards/TableCardSearchHeader.vue';
import UiFilters from '@/views/Dashboard/MediaBuying/UiFilters/UiFilters.vue';
import PeriodWrapper from '@/views/Dashboard/Reports/Filters/PeriodWrapper.vue';
import formatCurrency from '@/mixins/format-currency';
import UITableLinks from '@/components/ui/UITableLinks.vue';
import { useTooltip } from '@/helpers/tooltip';
import UiTableAction from '@/components/ui/UiTableAction.vue';
import UiTablePopoverAction from '@/components/ui/UiTablePopoverAction.vue';

const fieldMap = {
  post_status: 'status',
  post_type: 'type',
  // period: 'post_period_start',
  post_sum: 'amount',
  status: 'post_status',
  type: 'post_type',
  post_period_start: 'period',
  amount: 'post_sum',
  payment_sum: 'amount_usd',
};

const classes = {
  approved: 'text-green',
  on_review: 'text-orange',
  declined: 'text-red',
  paid: 'text-green',
  processing: 'text-orange',
  not_paid: 'text-red',
  for_rework: 'text-red',
  failed: 'text-red',
  draft: 'text-blue',
};

const defaultParams = {
  page: 1,
  pageSize: 20,
  search: '',
  prop: 'created_at',
  order: 'desc',

  typePosts: JSON.parse(localStorage.getItem('/dashboard/media-buying-posts'))?.typePosts || '',
  statusPosts: JSON.parse(localStorage.getItem('/dashboard/media-buying-posts'))?.statusPosts || '',

  created_at_from: JSON.parse(localStorage.getItem('/dashboard/media-buying-posts'))?.created_at_from
    || '',
  created_at_to: JSON.parse(localStorage.getItem('/dashboard/media-buying-posts'))?.created_at_to
    || '',
  period: JSON.parse(localStorage.getItem('/dashboard/media-buying-posts'))?.period || 2,

};

const tableFlowMixin = tableFlowMixinGenerator({
  defaultParams: {
    ...defaultParams,
  },
  offset: 0,
  limit: defaultParams.pageSize,
  params: Object.keys(defaultParams),
  sortByName: 'prop',
  sortDirName: 'order',
  fetchOnActivated: false,
});

export default {
  // name: 'PostsTableView',
  name: 'PostsViewTable',

  components: {
    AddPost,
    ShowPost,
    TableCard,
    TableCardSearchHeader,
    UiFilters,
    PeriodWrapper,
  },

  mixins: [
    UrlMixin,
    UrlMixinHooks,
    InjectPlugins,
    pageSizeMixin,
    tableFlowMixin,
    formatCurrency,
  ],

  props: ['statusChannel', 'statusCampaign', 'activeTab', 'tableSorting'],
  emits: ['update'],
  setup: () =>  {
    const { tooltipFormatter } = useTooltip();
    return { tooltipFormatter };
  },
  data() {
    const pageSize = Number(JSON.parse(localStorage.getItem('/dashboard/media-buying-posts'))?.limit) || 20;

    return {
      pageSize,
      limit: pageSize,
      route: 'promoMaterials',
      period: { from: '', to: '', period: 2 },
      filters: this.getDefaultFilter(),
      availableFilters: ['statusPosts', 'typePosts'],

      typePost: '',
      status: '',

      statusFiltersSettings: {
        minimumResultsForSearch: Infinity,
      },

      activePopperCount: null,
      actionRequired: true,

      columns: [
        {
          name: 'incrementing_id',
          align: 'left',
          filterable: false,
          sortable: 'custom',
          width: 60,
          renderValue: (v, row) => `
                  <span>${v}</span>`,
        },
        {
          name: 'campaign_name',
          align: 'left',
          filterable: true,
          minWidth: 140,
          // customTooltip: true,
          linkAppend: (item) => {
            const isRoot = item.campaign_id === item.root_campaign_id;
            return h(
              'span',
              {
                class: 'name-bubble !tw-flex !tw-justify-between',
                onClick: () => { this.handleCampaignPush('', '', item); },
              },
              [
                h(
                  'span',
                  {
                    class: 'link',
                  },
                  isRoot ? `${item.campaign_name}` : `${item.root_campaign_name} (${item.campaign_name})`,
                ),
              ],
            );
          },
        },
        // {
        //   name: 'campaign_name',
        //   align: 'left',
        //   filterable: true,
        //   minWidth: 140,
        //   // customTooltip: true,
        //   renderValue: v => `<span class="name-bubble ffff !tw-flex !tw-justify-between">
        //                       <span class="dark-green">${v}</span>
        //                     </span>`,
        // },
        {
          name: 'post_type',
          align: 'center',
          filterable: false,
          // sortable: 'custom',
          width: 95,
          renderValue: (v) => `<span class='${v === 'publication' ? 'text-green' : 'text-red'}'>
              ${this.$t(`mediaBuying.posts.type.${v}`)}
            </span>`,
        },
        {
          name: 'post_status',
          align: 'center',
          filterable: true,
          class: 'call-alert',
          width: 100,
          renderValue: (v, row) => `<span class='${classes[v]} wrap-red-alert' >
                              ${this.$t(`mediaBuying.posts.status.${v}`)}
                                <span class='text-red text-red-alert'>
                                  ${row.needs_attention
    ? '<i class="fas fa-exclamation-circle pl-2"></i>'
    : ''
}
                                </span>
                            </span>`,
        },
        {
          name: 'payment_sum',
          align: 'right',
          filterable: false,
          sortable: 'custom',
          width: 100,
        },
        {
          name: 'period_line',
          align: 'left',
          filterable: false,
          width: 258,
          // sortable: false,
          renderValue: (v, row) => `${moment(
            new Date(row.post_period_start),
            'YYYY-MM-DD HH:mm',
          ).format('DD MMM YYYY HH:mm')} - ${moment(
            new Date(row.post_period_end),
            'YYYY-MM-DD HH:mm',
          ).format('DD MMM YYYY HH:mm')}`,
        },
        {
          name: 'platform_name',
          align: 'left',
          filterable: false,
          // sortable: 'custom',
          customTooltip: false,
          width: 165,
          linkAppend: (item) => {
            return  h(
              UITableLinks,
              {
                list: item.platform_name,
              },
            );
          },
        },
        {
          name: 'created_at',
          align: 'left',
          sortable: 'custom',
          filterable: false,
          width: 155,
          format: 'date-time',
          source: 'i18n',
          i18nPath: 'reports',
        },
        {
          name: 'updated_at',
          align: 'left',
          sortable: 'custom',
          filterable: false,
          width: 155,
          format: 'date-time',
          source: 'i18n',
          i18nPath: 'reports',
        },
      ],
      formaters: Formatters,
    };
  },

  watch: {
    filters: {
      immediate: true,
      handler(value) {
        let _value = value;
        if (!value) {
          this.filter = this.getDefaultFilter();
          _value = this.filter;
        }

        this.typePosts = _value.typePosts;
        this.statusPosts = _value.statusPosts;
      },
    },

    // tableSorting: {
    //   immediate: true,
    //   deep: true,
    //   handler(value) {
    //     this.sorting = {
    //       prop: fieldMap[value.sort_column] || value.sort_column,
    //       order: value.sort_dir,
    //     };
    //   },
    // },
  },

  computed: {
    iconPlatform() {
      return this.$store.state.misc.postPlatforms;
    },

    rows() {
      return this.$store.state.mediaBuying.posts.map((p) => ({
        ...p,
        post_status: p.status,
        post_type: p.type,
        post_sum: this.currencyFormatter(p.amount, p.payments_currency_code),
        period: `${moment(new Date(p.post_period_start), 'YYYY-MM-DD HH:mm')
          .locale(this.$i18n.locale)
          .format('DD MMM YYYY HH:mm')}
                  - ${moment(new Date(p.post_period_end), 'YYYY-MM-DD HH:mm')
          .locale(this.$i18n.locale)
          .format('DD MMM YYYY HH:mm')}`,
        platform_name: p.urls.map((data) => ({
          icon: this.iconPlatform.find((e) => e.id === (data.url_platform_id || data.platform_id))?.logo_base64,
          text: data.url,
        })),
        payment_sum: this.currencyFormatter(p.amount, p.currency_code),
      }));
    },

    isArchived() {
      return this.statusCampaign === 'archived';
    },

    actions() {
      const operations = [
        {
          name: 'watched',
          componentAlt: {
            component: UiTableAction,
            props: (row) => {
              const params = row.needs_attention
                ? {
                  tooltipContent: this.$t('tickets.header.markAsRead'),
                  iconClass:  'fa-regular fa-circle-exclamation-check',
                  colorPreset: 'green',
                }
                : {
                  tooltipContent: this.$t('tickets.header.markAsUnread'),
                  iconClass:  'fa-regular fa-exclamation-circle',
                  colorPreset: 'red',
                };

              return {
                ...params,
                onClick: () => {
                  this.markAction(row, row.needs_attention);
                },
              };
            },
          },
        },
        {
          name: 'show',
          componentAlt: {
            component: UiTableAction,
            props: (row) => ({
              tooltipContent: this.$t('mediaBuying.posts.show'),
              iconClass: 'far fa-eye',
              colorPreset: 'green',
              onClick: async () => {
                await this.$store.dispatch('getPost', row.id);
                this.showPost({ ...this.$store.state.mediaBuying.post, platform_name: row.platform_name });
              },
            }),
          },
        },
        {
          name: 'edit',
          componentAlt: {
            component: UiTableAction,
            props: (row) => ({
              tooltipContent: this.$t('mediaBuying.posts.edit'),
              iconClass: 'far fa-pen',
              colorPreset: 'green',
              disabled: !(row.status === 'draft' || row.status === 'for_rework'),
              onClick: async () => {
                await this.$store.dispatch('getPost', row.id);
                this.addPost({ ...this.$store.state.mediaBuying.post, platform_name: row.platform_name });
              },
            }),
          },
        },
        {
          name: 'review',
          componentAlt: {
            component: UiTableAction,
            props: (row) => ({
              tooltipContent: this.$t('mediaBuying.posts.show'),
              iconClass: 'far fa-check-double',
              colorPreset: 'orange',
              disabled: !(row.status === 'draft' || row.status === 'for_rework'),
              onClick: async () => {
                this.changeStatus(row);
              },
            }),
          },
        },
        {
          name: 'delete',
          componentAlt: {
            component: UiTablePopoverAction,
            props: (row) => ({
              tooltipContent: this.$t('promoCodes.promocodes.delete'),
              iconClass: 'far fa-trash-alt',
              colorPreset: 'red',
              disabled: row.status !== 'draft',
              width: 250,
              message: this.$t('mediaBuying.campaigns.delete_post_message'),
              buttons: [
                {
                  text: this.$t('mediaBuying.channels.cancel'),
                },
                {
                  text: this.$t('promoCodes.promocodes.delete'),
                  type: 'danger',
                  click: () => this.deletePost(row),
                },
              ],
            }),
          },
        },
      ];

      return {
        fixed: 'right',
        width: 160,
        name: () => this.$t('profile.apiKeys.table.actions'),
        operations,
      };
    },
  },

  methods: {
    async markAction(row, action) {
      if (action) {
        await this.$api.postPostMarkAsRead(row.id);
        this.$store.dispatch('getCampaignsAttentionCounters');
        this.fetchData(true);
      } else {
        await this.$api.postPostMarkAsUnread(row.id);
        this.$store.dispatch('getCampaignsAttentionCounters');
        this.fetchData(true);
      }
    },

    handleCampaignPush(id, ids, row) {
      if (row.root_campaign_id === row.campaign_id) {
        this.$router.push(
          `/dashboard/media-buying-campaigns-details/${row.campaign_id}/${this.compressUrlQuery({
            ...row,
            campaign_id: row.campaign_id,
            status: '',
            period: this.period,
            activeTab: 'posts',
          })}`,
          () => {this.$refs.datatable.clearTooltips();},
        );
      } else {
        localStorage.setItem(
          'getBackUrlCampaign',
          JSON.stringify(`/dashboard/media-buying-campaigns-details/${row.root_campaign_id}/${this.compressUrlQuery({
            ...row,
            campaign_id: row.root_campaign_id,
            status: '',
            needsAttention: {
              payments: row.needs_attention_payments,
              posts: row.needs_attention_posts,
              total: row.needs_attention_total,
            },
          })}`),
        );

        this.$router.push(
          `/dashboard/media-buying-campaigns-sub/${row.campaign_id}/${this.compressUrlQuery({
            ...row,
            campaign_name: row.root_campaign_name,
            campaign_id: row.campaign_id,
            status: '',
            period: this.period,
            activeTab: 'posts',
            needsAttention: {
              payments: row.needs_attention_payments,
              posts: row.needs_attention_posts,
              total: row.needs_attention_total,
            },
            // nestedSettingView,
          })}`,
          () => {this.$refs.datatable.clearTooltips();},
        );
      }
      this.$refs.datatable.clearTooltips();
      document.removeEventListener('mouseup', this.listener);
    },

    changePeriod() {
      this.fetchData();
    },

    async inputFilter(data) {
      this.filters = data;
      this.page = 1;
      this.update();
    },

    reset() {
      this.filters = null;
      this.update();
    },

    initFilter(query) {
      const filters = this.$_.pick(query, ['typePosts', 'statusPosts']);
      const defaultFilters = this.$_.pick(defaultParams, ['typePosts', 'statusPosts']);

      this.filters = {
        ...defaultFilters,
        ...this.filters,
        ...filters,
      };
    },

    getDefaultFilter() {
      return {
        typePosts: defaultParams.typePosts,
        statusPosts: defaultParams.statusPosts,
      };
    },

    async addPost(row) {
      const balanceEmpty = Object.values(this.$store.state.mediaBuying.campaign.balances?.approved || {})
        .every((el) => el <= 0);

      if (!balanceEmpty || row.id) {
        this.$refs.addPost.open(row);
        if (row.needs_attention) {
          await this.markAction(row, row.needs_attention);
          this.$store.dispatch('getCampaignsAttentionCounters');
        }
      } else {
        this.$alert.error(this.$t('mediaBuying.campaign.zero_balance_error'));
      }
    },

    async showPost(row) {
      this.$refs.showPost.open(row);
      if (row.needs_attention) {
        await this.markAction(row, row.needs_attention);
        this.$store.dispatch('getCampaignsAttentionCounters');
      }
    },
    changeStatus(row) {
      this.$store.dispatch('postToReview', row.id).then(() => {
        this.update();
        this.$alert.success(this.$t('mediaBuying.campaign.review_message'));
      });
    },

    deletePost(row) {
      this.$store.dispatch('deletePost', row.id).then(() => this.update());
    },

    update(silent) {
      this.$emit('update', {
        tab: 'posts',
        prop: this.sorting.prop,
        order: this.sorting.order,
        search: this.search,
        status: this.filters?.statusPosts || '',
        type: this.filters?.typePosts || '',
        needs_attention_first: this.actionRequired,
        created_at_from: this.period.from,
        created_at_to: this.period.to,
        period: this.period.period,

        ...this.offsetParams,
      }, undefined, silent);
    },

    async fetchData(silent) {
      this.$nextTick(() => this.update(silent));
    },

    currencyFormatter(amount, code) {
      amount = amount.toFixed(2);
      const amountData = amount.split('.');
      const result = (+amountData[0]).toLocaleString();

      return `${this.getCurrencyLabel(code)}${result}.${amountData[1]}`;
    },
  },

  created() {
    this.typePost = this.getUrlQueryParam('type');
    this.status = this.getUrlQueryParam('status');

    this.$store.dispatch('getPostPlatforms', {});

    this.actions.operations.map((e) => {
      if (e.component) {
        e.component = e.component.bind(this);
      }
    });
  },
};
</script>
